import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import * as S from './Footer.styled';
import { CLUB_INFO, NAVIGATION } from '@utils/constants.js';
import { analytics } from '@utils/analytics.js';
import { VkIcon, TelegramIcon, YandexMapsIcon } from '../Icons';

const Footer = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleLinkClick = (path, name) => {
    analytics.trackEvent('Navigation', 'footer_click', name);
    if (location.pathname === path) {
      scrollToTop();
    } else {
      navigate(path);
      setTimeout(scrollToTop, 100);
    }
  };

  const handleSocialClick = (platform, url) => {
    analytics.trackSocialClick(platform);
    window.open(url, '_blank');
  };

  const handlePhoneClick = () => {
    analytics.trackPhoneClick();
    // Для звонка используем номер с + для максимальной совместимости
    window.location.href = `tel:${CLUB_INFO.phone || '+79219334440'}`;
  };

  return (
    <S.Footer>
      <div className="footer-content">
        <div className="footer-contacts">
          <h3 className="footer-nav-title">Контакты</h3>
          
          <div className="footer-contact-item">
            <strong>Телефон:</strong>
            <a href={`tel:${CLUB_INFO.phoneRaw || '79219334440'}`} onClick={handlePhoneClick}>
              {CLUB_INFO.phoneDisplay || '+7 (921) 933-44-40'}
            </a>
          </div>
          
          <div className="footer-contact-item">
            <strong>Адрес:</strong>
            <a 
              href={CLUB_INFO.maps.yandex} 
              target="_blank" 
              rel="noopener noreferrer"
              className="address-link"
              onClick={() => handleSocialClick('yandex-maps', CLUB_INFO.maps.yandex)}
            >
              {CLUB_INFO.address || 'Мельничная улица 1, Петергоф'}
            </a>
          </div>
          
          <div className="footer-contact-item">
            <strong>Часы работы:</strong>
            <span>{CLUB_INFO.hours || 'Пн-Вс: 07:00 - 03:00'}</span>
          </div>

          <div className="footer-social-links">
            <button 
              onClick={() => handleSocialClick('vk', CLUB_INFO.social?.vk)}
              className="footer-social-link vk"
              title="ВКонтакте"
              aria-label="ВКонтакте"
            >
              <VkIcon size={22} />
            </button>
            <button 
              onClick={() => handleSocialClick('telegram', CLUB_INFO.social?.telegram)}
              className="footer-social-link telegram"
              title="Telegram"
              aria-label="Telegram"
            >
              <TelegramIcon size={22} />
            </button>
            <button 
              onClick={() => handleSocialClick('yandex-maps', CLUB_INFO.maps?.yandex)}
              className="footer-social-link yandex-maps"
              title="Открыть в Яндекс Картах"
              aria-label="Яндекс Карты"
            >
              <YandexMapsIcon size={22} />
            </button>
          </div>
        </div>

        <nav className="footer-nav">
          <h3 className="footer-nav-title">Навигация</h3>
          <ul className="footer-nav-list">
            {NAVIGATION.footer.map((item) => (
              <li key={item.path} className="footer-nav-item">
                <button 
                  onClick={() => handleLinkClick(item.path, item.name)}
                  className="styled-footer-link"
                >
                  {item.name}
                </button>
              </li>
            ))}
          </ul>
        </nav>
      </div>

      <div className="footer-bottom">
        <div className="footer-bottom-content">
          <div className="copyright">
            © 2026 Князево Club <span className="version">v{__APP_VERSION__}</span>
          </div>
        </div>
      </div>
    </S.Footer>
  );
};

export default Footer;